import './App.css';
import AppRouter from '../src/pages/route/route';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
function App() {
  return (
    <AppRouter />
  );
}

export default App;
